package xim.poc.game.configuration.v0.tactics

import xim.math.Vector3f
import xim.poc.ActorId
import xim.poc.ActorManager
import xim.poc.ModelLook
import xim.poc.NoOpActorController
import xim.poc.game.*
import xim.poc.game.configuration.*
import xim.poc.game.configuration.v0.FloorEntity
import xim.poc.game.configuration.v0.GameV0
import xim.poc.game.configuration.v0.ZoneLogic
import xim.poc.game.configuration.v0.interactions.NpcInteraction
import xim.poc.game.event.InitialActorState
import xim.poc.gl.ByteColor
import xim.poc.tools.ZoneConfig
import xim.resource.DatId
import xim.util.Fps
import kotlin.time.Duration.Companion.seconds

private fun makeScript(destination: ZoneConfig, zoneLogicFn: (() -> ZoneLogic)? = null): EventScript {
    return EventScript(
        listOf(
            ActorRoutineEventItem(fileTableIndex = 0x11427, actorId = ActorStateManager.playerId, eagerlyComplete = true, routineId = DatId("s000")),
            WaitRoutine(0.7.seconds),
            FadeOutEvent(1.seconds),
            WarpZoneEventItem(destination, fade = false),
            RunOnceEventItem {
                zoneLogicFn?.let { GameV0.setZoneLogic(it) }
                ActorManager.player().renderState.effectColor = ByteColor.zero
            },
            WaitRoutine(Fps.secondsToFrames(0.2f)),
            ActorRoutineEventItem(fileTableIndex = 0x11428, actorId = ActorStateManager.playerId, eagerlyComplete = true, routineId = DatId("s000")),
            FadeInEvent(1.seconds),
        )
    )
}

object TacticsEntranceInteraction: NpcInteraction {

    override fun onInteraction(npcId: ActorId) {
        UiStateHelper.openQueryMode("Play a turn-based mini-game?", getOptions()) { handleQueryResponse(npcId, it) }
    }

    private fun getOptions(): List<QueryMenuOption> {
        return listOf(
            QueryMenuOption("Yes!", 1),
            QueryMenuOption("No.", -1)
        )
    }

    private fun handleQueryResponse(npcId: ActorId, response: QueryMenuOption?): QueryMenuResponse {
        if (response == null || response.value < 0) { return QueryMenuResponse.pop }
        EventScriptRunner.runScript(makeScript(TacticsZoneInstance.entryPosition) { TacticsZoneInstance() })
        return QueryMenuResponse.popAll
    }

}

object TacticsExitInteraction: NpcInteraction {

    override fun onInteraction(npcId: ActorId) {
        ActorManager[npcId]?.enqueueModelRoutine(DatId("on00"))
        UiStateHelper.openQueryMode("Return to base camp?", getOptions()) { handleQueryResponse(npcId, it) }
    }

    private fun getOptions(): List<QueryMenuOption> {
        return listOf(
            QueryMenuOption("Yes.", 1),
            QueryMenuOption("No.", -1)
        )
    }

    private fun handleQueryResponse(npcId: ActorId, response: QueryMenuOption?): QueryMenuResponse {
        if (response == null || response.value < 0) { return QueryMenuResponse.pop }
        EventScriptRunner.runScript(makeScript(GameV0.configuration.startingZoneConfig))
        return QueryMenuResponse.popAll
    }

}

class TacticsExitNpc(val location: Vector3f): FloorEntity {

    private val promises = ArrayList<ActorPromise>()

    init {
        spawn()
    }

    override fun update(elapsedFrames: Float) { }

    override fun cleanup() {
        promises.forEach { it.onReady { a -> GameEngine.submitDeleteActor(a.id) } }
    }

    private fun spawn() {
        promises += GameEngine.submitCreateActorState(
            InitialActorState(
                name = "Exit",
                type = ActorType.StaticNpc,
                position = location,
                staticPosition = true,
                modelLook = ModelLook.npc(0x032),
                movementController = NoOpActorController(),
                behaviorController = NoActionBehaviorId,
                maxTargetDistance = 10f,
            )
        ).onReady {
            GameV0.interactionManager.registerInteraction(it.id, TacticsExitInteraction)
        }
    }

}